import * as React from "react";

import CostForm from "../../../components/Forms/ServiceContract/CostForm/FlowForm";

export default function ServiceContractCostForm() {
  return <CostForm />;
}
